import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core'
import { ChatModel } from '@models/chat.model'
import { ChatService, ModalService } from '@app/services'
import { APP_CONFIG, Config, ConfigService } from '@services/config.service'

@Component({
    selector: 'app-communication-item',
    templateUrl: './communication-item.component.html',
    styleUrls: ['./communication-item.component.css'],
})
export class CommunicationItemComponent implements OnInit {
    @Input() chatItem: ChatModel
    @Input() staffList
    @Input() clinicSeenAt: any
    @Output() _onShowImage: EventEmitter<any> = new EventEmitter()
    public doctorName: string
    public doctorDeleted
    public staffName: string
    public staffDeleted
    public config: Config

    constructor(public chatService: ChatService,
                private modalService: ModalService,
                public configService: ConfigService,
                @Inject(APP_CONFIG) config: Config) {
        this.config = config
    }

    ngOnInit() {
        if (this.configService.config) {
            const doctor = this.configService.getDoctor(this.chatItem['doctor'])
            this.doctorDeleted = doctor ? doctor.deleted : ''
            this.doctorName = doctor ? doctor['name'] : ''

            const configStaff = this.configService.getStaff(this.chatItem['staff'])
            this.staffDeleted = configStaff ? configStaff.deleted : ''
            let fullname = '';
            let firstName = configStaff ? configStaff['firstName'] : ''
            let familyName = configStaff ? configStaff['familyName'] : ''
            if(firstName && familyName) fullname = firstName + ' ' + familyName
            if(firstName && !familyName) fullname = firstName
            if(!firstName && familyName) fullname = familyName
            this.staffName = configStaff ? fullname : ''             // if(this.staffList){
            //     const staff = this.staffList.filter(function (el) {
            //         return el.firstName == configStaff['firstName'] 
            //       })[0];
            //     this.staffDeleted = staff ? staff.deleted : ''
            //     if (staff) {
            //         const names = [staff['firstName'], staff['familyName']]
            //         this.staffName = names.filter(i => !!i).join(' ')
            //     } else {
            //         this.staffName = ''
            //     }
    
            // }
        }
    }

    openTimeline(item: ChatModel, itemId = '') {
        let elementId = null
        if (itemId) {
            elementId = `reply_time_${ itemId }`
        }

        const arrMessage = ['showModalChatDetail', item._id, false, elementId]
        this.modalService.emitChange(arrMessage)
    }

    compactString(str: string) {
        if (str) {
            str = str.replace(/\s{2,}/g, ' ')
            const max = 50
            return str.length > max
                ? str.substring(0, max) + '...'
                : str
        }
    }

    disableModal(event) {
        if (event.target.tagName.toLowerCase() === 'a') {
            event.stopPropagation()
        }
    }

    onReaction(event: number) {
        this.chatService.updateReaction(this.chatItem._id, {
            clinicReact: this.chatItem.clinicReact || 0,
            patientReact: this.chatItem.patientReact || 0,
        })
    }

    scrollTo(event, communicationId: any) {
        event.stopPropagation()
        const elementId = 'chat_' + communicationId
        setTimeout(() => {
            if (document.getElementById(elementId)) {
                document.getElementById(elementId).scrollIntoView()
            } else {
                console.warn('element not found', elementId)
            }
        }, 100)
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/client-detail/communication/communication-item/communication-item.component.ts